import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function Error() {
    const navigate = useNavigate();
    const location = useLocation();
    let errormessage = "주소 변경 또는 잘못된 주소 입력, 주소 삭제로 접근이 안되시거나, 예기치 못한 오류가 발생하여 해당 화면으로 접근이 불가능합니다.";
    console.log(location)
    const goBack = () => {
        navigate(-1, { replace: true });
    }

    return (
        <div className='ERROR_CONTAIN'>
            <div className="ERROR">
                <h1>이용에 불편을 드려 죄송합니다</h1>
                <div className="box">
                    <p>
                        {errormessage}
                    </p>
                    <div className="btn_area">
                        <button className="detail_btn"
                            onClick={goBack}>이전 페이지</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Error;